import React from "react";

import { view } from "modules/Activity";

const NotificationsPage = () => {
	return <view.Notifications />;
};

export default NotificationsPage;
